export const START_FETCHING_LISTS_CATEGORIES =
  'redux/lists/START_FETCHING_LISTS_CATEGORIES';
export const SUCCESS_FETCHING_LISTS_CATEGORIES =
  'redux/lists/SUCCESS_FETCHING_LISTS_CATEGORIES';
export const ERROR_FETCHING_LISTS_CATEGORIES =
  'redux/lists/ERROR_FETCHING_LISTS_CATEGORIES';

export const START_FETCHING_LISTS_TALENTS =
  'redux/lists/START_FETCHING_LISTS_TALENTS';
export const SUCCESS_FETCHING_LISTS_TALENTS =
  'redux/lists/SUCCESS_FETCHING_LISTS_TALENTS';
export const ERROR_FETCHING_LISTS_TALENTS =
  'redux/lists/ERROR_FETCHING_LISTS_TALENTS';

export const START_FETCHING_LISTS_EVENTS =
  'redux/lists/START_FETCHING_LISTS_EVENTS';
export const SUCCESS_FETCHING_LISTS_EVENTS =
  'redux/lists/SUCCESS_FETCHING_LISTS_EVENTS';
export const ERROR_FETCHING_LISTS_EVENTS =
  'redux/lists/ERROR_FETCHING_LISTS_EVENTS';